import Autocomplete from "../../common/components/base/Autocomplete";
import React from "react";
import LoadingAnimation from "../../common/components/base/LoadingAnimation";
import { useSimulation } from "../../hooks/useSimulation";

const PlacementAutocomplete = (props) => {
  const { data, isLoading, error } = useSimulation('pl');

  if (isLoading) return <LoadingAnimation />;
  if (error) return `Error! ${error.message}`;
  const placements = data?.placementsSimulation || [];

  return (
    <Autocomplete 
      handleChange={props.handleChange}
      single={props.single}
      selectedValue={props.selectedValue}
      values={placements.map(value => ({ value: value.name, label: value.name }))}
      placeholder={props.placeholder}
    />
  );
};

export default PlacementAutocomplete;
